module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/th-2ca3db46e2b26412705d4c1c0b6ced04.svg";